import curry from "./curry";
import toDate from "./toDate";
import isNil from "./isNil";

//  String -> Date|String|undefined -> String
const formatDate = curry((f, d) => (isNil(d) ? d : toDate(d).format(f)));

export default formatDate;
